module.exports = __webpack_public_path__ + "img/pic1.abe3cf11.png";